import { ChatAiWidget } from "@sendbird/chat-ai-widget";
import { OnWidgetOpenStateChangeParams } from "@sendbird/chat-ai-widget/dist/src/const";
import config from 'api/config';
import { useEffect } from "react";
const appId = config.sendbird.appId;
const botId = config.sendbird.botId;

const ChatWidget = ({
    enableEmojiFeedback = true,
    enableMention = true,
    autoOpen = false,
    enableWidgetExpandButton = false,
    enableResetHistoryOnConnect = true,
    betaMark = true,
}) => {
    useEffect(() => {
        const FASTCLICK_CLASSNAME = 'no-fastclick';
        const timer = setTimeout(() => {
            const toggleInput = document.getElementById('sendbird-message-input-text-field');
            if (toggleInput instanceof HTMLElement) {
                toggleInput.classList.add(FASTCLICK_CLASSNAME);
            }
            if (autoOpen) {
                const toggleButton = document.querySelector('#aichatbot-widget-button');
                if (toggleButton instanceof HTMLElement) {
                    toggleButton.click();
                }
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [autoOpen]);

    return (
        <ChatAiWidget
            applicationId={appId}
            botId={botId}
            enableEmojiFeedback={enableEmojiFeedback}
            enableMention={enableMention}
            autoOpen={autoOpen}
            deviceType={(window as any).cordova ? 'mobile' : 'desktop'}
            enableWidgetExpandButton={enableWidgetExpandButton}
            enableResetHistoryOnConnect={enableResetHistoryOnConnect}
            betaMark={betaMark}
        />
    );
};

export default ChatWidget;